<div class="stepper-container">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <!-- Main Stepper Title -->
        @if(config.title){
        <div class="stepper-title">
          {{ config.title | translate }}
        </div>
        }

        <p-stepper [(activeStep)]="currentStep" [linear]="config.linear || false"
          [orientation]="config.orientation || 'horizontal'" (activeStepChange)="onStepChange($event)">

          @for(step of config.steps; track step.id){
          <p-stepperPanel>
            <!-- Step Header Template -->
            <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
              <div class="stepper-header-title" [class.completed]="isStepCompleted(index)">

                <div class="stepper-header-number-container">
                  <!-- Completed step with check icon -->
                  @if(isStepCompleted(index)){
                  <span class="stepper-header-number-finished">
                    <i class="pi pi-check"></i>
                  </span>
                  } @else if(!isStepCompleted(index)){
                  <!-- Current or pending step with number or custom icon -->
                  <span class="stepper-header-number">
                    @if(step.icon){
                    <i [class]="step.icon"></i>
                    } @else {
                    <span>{{ getStepNumber(index) }}</span>
                    }
                  </span>
                  }
                </div>

                <div class="stepper-header-title-text-container">
                  <span class="stepper-header-title-text">
                    {{ step.title | translate }}
                  </span>

                  <!-- Show selected item if configured and available in step data -->
                  @if(step.showSelectedItem && step.selectedItemKey && getStepData(index)[step.selectedItemKey]){
                  <span class="stepper-header-title-selected-item">
                    {{publicService.getCurrentLang() === 'en' ? getStepData(index)[step.selectedItemKey].englishName :
                    getStepData(index)[step.selectedItemKey].arabicName}}
                  </span>
                  }
                </div>
              </div>
            </ng-template>

            <!-- Step Content Template -->
            <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback"
              let-index="index">
              <div class="stepper-content">
                <!-- Dynamic component container -->
                <div #dynamicContent></div>

                <!-- Navigation buttons -->
                @if(step.showBackButton !== false || step.showNextButton !== false){
                <div class="stepper-navigation">
                  <div class="d-flex pt-4 justify-content-between">
                    <!-- Cancel Button -->
                    @if(step.showCancelButton !== false){
                    <p-button (onClick)="onCancelStep()"
                      [label]="(step.cancelButtonLabel || 'GENERAL.CANCEL') | translate" severity="secondary" />
                    }

                    <!-- Back button -->
                    @if(step.showBackButton !== false && index > 0){
                    <p-button (onClick)="onPreviousStep()"
                      [label]="(step.backButtonLabel || 'GENERAL.BACK') | translate" severity="secondary" />
                    }

                    <!-- Next button -->
                    @if(step.showNextButton !== false){
                    <p-button (onClick)="onNextStep()" [label]="(step.nextButtonLabel || 'GENERAL.NEXT') | translate"
                      severity="primary" [disabled]="step.nextButtonDisabled" [loading]="step.nextButtonLoading" />
                    }
                  </div>
                </div>
                }
              </div>
            </ng-template>
          </p-stepperPanel>
          }
        </p-stepper>
      </div>
    </div>
  </div>
</div>
